// extracted by mini-css-extract-plugin
export default {"container":"radio_container__Ft5dM","radio":"radio_radio__IeTRJ","label":"radio_label__HF8T6"};